import { clsx } from 'clsx'
import { type FC, type ReactNode } from 'react'

interface NfcLandingPageTitleProps {
  children: ReactNode
  className?: string
}

export const NfcLandingPageTitle: FC<NfcLandingPageTitleProps> = ({
  children,
  className,
}) => {
  return (
    <h2
      className={clsx(
        'text-center text-xl font-medium tablet:text-left desktop:text-2xl',
        className,
      )}
    >
      {children}
    </h2>
  )
}
